import jwtDecode from 'jwt-decode';
import { V1Axios, V2Axios } from 'src/utils/server';

let authorisation;

class AuthService {
  setAxiosInterceptors = ({ onLogout }) => {
    const handleError = (error) => {
      if (error.response && error.response.status === 401) {
        this.setSession(null);
        if (onLogout) {
          onLogout();
        }
      }
      return Promise.reject(error);
    };
    V1Axios.interceptors.response.use(
      (response) => response,
      (error) => {
        handleError(error);
      }
    );
    V2Axios.interceptors.response.use(
      (response) => response,
      (error) => {
        handleError(error);
      }
    );
  };

  handleAuthentication() {
    const accessToken = this.getAccessToken();

    if (!accessToken) {
      return;
    }

    if (this.isValidToken(accessToken)) {
      this.setSession(accessToken);
    } else {
      this.setSession(null);
    }
  }

  async loginWithEmailAndPassword(email, password) {
    try {
      const response = await V1Axios.post(`/admin/login`, {
        email,
        password,
      });
      if (response.data.user) {
        this.setSession(response.data.accessToken);
        return response.data.user;
      } else {
        throw new Error(response.data.error);
      }
    } catch (error) {
      throw new Error(error);
    }
  }

  loginInWithToken = () =>
    new Promise((resolve, reject) => {
      console.log('loginWithToken');
      V1Axios.get(`/admin/loginWithToken/${authorisation}`)
        .then((response) => {
          if (response.data.user) {
            resolve(response.data.user);
          } else {
            reject(response.data.error);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  logout = () => {
    this.setSession(null);
  };

  setSession = (accessToken) => {
    if (accessToken) {
      localStorage.setItem('accessToken', accessToken);
      V1Axios.defaults.headers.common.Authorization = `Bearer ${accessToken}`;
      V2Axios.defaults.headers.common.Authorization = `Bearer ${accessToken}`;
      authorisation = `Bearer ${accessToken}`;
    } else {
      localStorage.removeItem('accessToken');
      sessionStorage.removeItem('dashboard_filter');
      delete V1Axios.defaults.headers.common.Authorization;
      delete V2Axios.defaults.headers.common.Authorization;
    }
  };

  getAccessToken = () => localStorage.getItem('accessToken');

  isValidToken = (accessToken) => {
    if (!accessToken) {
      return false;
    }

    const decoded = jwtDecode(accessToken);
    const currentTime = Date.now() / 1000;

    return decoded.exp > currentTime;
  };

  isAuthenticated = () => !!this.getAccessToken();
}

const authService = new AuthService();

export default authService;
